import {useTranslation} from "react-i18next";
import {BulkUploader} from "../../../upload/bulk-upload.tsx";
import {
    ManifestType,
    ManifestTypeUpsertResult,
    UpsertableManifestType,
    upsertManifestTypeVerb,
} from "../../../rpc/webrpc-client.gen.ts";
import {Box} from "@mui/joy";
import {createFileRoute} from "@tanstack/react-router";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {useMothership} from "../../../tq/tqx.tsx";

interface CsvManifestTypeFood {
    code: string;
    displayName: string;
}

function ManifestTypeCapsule({manifestType}: { manifestType: UpsertableManifestType | ManifestType }) {
    return <Box>{manifestType.code}・{manifestType.displayName}</Box>;
}

function AdminManifestType() {
    const {t} = useTranslation();
    const mama = useMothership();
    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <BulkUploader<CsvManifestTypeFood, UpsertableManifestType, ManifestTypeUpsertResult>
                entityTypeLabel={t("entity.manifestType")}
                csvToUpsertFood={(csv) => csv}
                upsertFoodCapsule={(food) =>
                    <ManifestTypeCapsule manifestType={food}/>
                }
                upsertTqo={{
                    mutationKey: [upsertManifestTypeVerb],
                    mutationFn: (args) => mama.upsertManifestType(args)
                        .then(tqrv => tqrv.result),
                }}
                existingId={(result) => result.existingId ?? null}
                newId={(result) => result.newId ?? null}
                completedCapsule={({food}) =>
                    <ManifestTypeCapsule manifestType={food}/>
                }
                conflictCapsules={(urv) => {
                    return urv.conflict ? [<ManifestTypeCapsule key={urv.conflict.id}
                                                                manifestType={urv.conflict}/>] : null;
                }}
            />
        </PageBody>
    </PageShell>
}

export const Route = createFileRoute("/_auth/admin/manifest-type")({
    component: AdminManifestType,
});

